import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import Axios from "axios";
import Store from "../../index";

const name = "setting";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true })
export default class SettingModule extends VuexModule {
  newVersionValue: string = "";
  oldVersionValue: string = "";

  @Mutation
  setNewVersionValue(payload) {
    this.newVersionValue = payload;
  }

  @Mutation
  setOldVersionValue(payload) {
    this.oldVersionValue = payload;
  }

  @Action
  async getVersion() {
    const defaultOptions = {};
    const rawApi = Axios.create(defaultOptions);
    let url = "/version";
    try {
      const response = await rawApi.get(url);
      return response;
    } catch (error) {}
  }

  get currentVersion() {
    return this.newVersionValue;
  }

  get previousVersion() {
    return this.oldVersionValue;
  }
}
